import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { AlertMessage, AlertMessageType, AlertMessageStatus } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

    constructor(
        private apiService: ApiService
    ) {}

    async loadAlertMessages(): Promise<AlertMessage[]>{
        let messages: Array<AlertMessage> = [];
        
        // A MODIFIER
        messages = [{
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Présence confirmée',
            body: 'La présence de l\'intervenant pour la mission dans le magasin AUCHAN VELIZY en date du 02/10/2025 pour la campagne MERCH 2025 a été validée',
            date: new Date(),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },{
            type: AlertMessageType.FromAlertMessage('WARNING'),
            title: 'J-5 avant fermeture de la campagne MERCH 2025',
            body: 'Il vous reste 5 jours pour réaliser des demandes d\'interventions avant la fermeture de la campagne MERCH 2025 (le 04/10/2025)',
            date: new Date('2025-09-30'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('SUCCESS'),
            title: 'Validation de votre demande d\'intervention',
            body: 'Votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin LECLERC BOIS D\'ARCY pour la date du 09/10/2025 a été validée',
            date: new Date('2025-09-29'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin AUCHAN VELIZY pour la date du 02/10/2025',
            date: new Date('2025-09-29'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin LECLERC RAMBOUILLET pour la date du 01/10/2025',
            date: new Date('2025-09-29'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin CARREFOUR MASSY pour la date du 01/10/2025',
            date: new Date('2025-09-28'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('SUCCESS'),
            title: 'Réalisation de l\'intervention',
            body: 'L\'intervention dans le magasin LECLERC BOIS D\'ARCY en date du 09/10/2025 pour la campagne MERCH 2025 a été terminée. Vous pouvez consulter le compte-rendu d\'intervention',
            date: new Date('2025-09-29'),
            status: AlertMessageStatus.FromAlertMessage('READ')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin AUCHAN VELIZY pour la date du 02/10/2025',
            date: new Date('2025-09-21'),
            status: AlertMessageStatus.FromAlertMessage('READ')
        },
        {
            type: AlertMessageType.FromAlertMessage('ERROR'),
            title: 'Annulation de l\'intervention',
            body: 'Votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin AUCHAN VILLEBON SUR YVETTE pour la date du 08/10/2025 a été annulée',
            date: new Date('2025-09-21'),
            status: AlertMessageStatus.FromAlertMessage('UNREAD')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin LECLERC RAMBOUILLET pour la date du 01/10/2025',
            date: new Date('2025-09-21'),
            status: AlertMessageStatus.FromAlertMessage('READ')
        },
        {
            type: AlertMessageType.FromAlertMessage('INFO'),
            title: 'Affectation d\'un intervenant',
            body: 'Un intervenant a été affecté pour votre demande d\'intervention pour la campagne MERCH 2025 dans le magasin CARREFOUR MASSY pour la date du 01/10/2025',
            date: new Date('2025-09-20'),
            status: AlertMessageStatus.FromAlertMessage('READ')
        },
        ];
        
        return messages;
    }

}


